/* unplugin-vue-components disabled */import script from "./Reg.vue?vue&type=script&setup=true&lang=ts"
export * from "./Reg.vue?vue&type=script&setup=true&lang=ts"

import "./Reg.vue?vue&type=style&index=0&id=1e9c800f&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e9c800f"]])

export default __exports__